/* eslint-disable eqeqeq */
/* eslint-disable new-cap */
/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Controllers')
    .controller('DigitalSignatureController', DigitalSignatureController)

  DigitalSignatureController.$inject = ['NotificationService', 'DigitalSignService', 'Upload', 'FoundationApi', 'FormalizationProposalStatusService', '$http', '$rootScope']

  function DigitalSignatureController (NotificationService, DigitalSignService, Upload, FoundationApi, FormalizationProposalStatusService, $http, $rootScope) {
    const vm = this

    // functions
    vm.openPopover = openPopover
    vm.dateSelected = dateSelected
    vm.switchTab = switchTab
    vm.getContracts = getContracts
    vm.uploadContactInfo = uploadContactInfo
    vm.downloadUploadFiles = downloadUploadFiles
    vm.removeProposal = removeProposal
    vm.uploadContracts = uploadContracts
    vm.searchContracts = searchContracts
    vm.generateDocumentBySubscription = generateDocumentBySubscription
    vm.approveProposals = approveProposals
    vm.selectAllProposals = selectAllProposals
    vm.callUploadProposalButton = callUploadProposalButton
    vm.updateDocumentsInfo = updateDocumentsInfo
    vm.resubmitProposal = resubmitProposal
    vm.downloadReport = downloadReport
    vm.scrollHandle = scrollHandle
    vm.goToButtonSaveDocuments = goToButtonSaveDocuments
    vm.confirmModal = confirmModal
    vm.closeConfirmModal = closeConfirmModal

    // variables
    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY'),
      flowName: 'b2b',
      count: 10
    }

    vm.popover = false
    vm.showTabSignature = true
    vm.showTabDocuments = false
    vm.preventDefault = false
    vm.hasUnsavedChanges = false

    getContracts()

    function getContracts (infiniteScroll) {
      if (vm.preventDefault) {
        return false
      }
      setPage(infiniteScroll)
      if (validateFields()) {
        DigitalSignService.getContactsByFilters(vm.filters)
          .$promise
          .then(function (data) {
            if (data.success && data.contacts.length > 0) {
              setData(data, infiniteScroll)
            } else {
              NotificationService.warningHandler('', 'Nenhum contrato foi encontrado')
              vm.contracts = null
            }
            clearData()
          })
          .catch(function (data) {
            NotificationService.errorHandler(data, 'Erro ao obter contratos')
          })
      }
    }

    function setPage (infiniteScroll) {
      if (infiniteScroll) {
        vm.filters.page++
        return true
      }
      vm.filters.page = 1
      return true
    }

    function setData (data, infiniteScroll) {
      if (vm.contracts && infiniteScroll) {
        vm.contracts.push(...createContractsArray(data.contacts))
      } else {
        vm.contracts = createContractsArray(data.contacts)
      }
      vm.currentQuantity = vm.contracts.length
      vm.totalAmount = data.total
      checkProposalsSent()
      checkProposalsSigned()
    }

    function clearData () {
      vm.proposals = null
      vm.documents = null
    }

    function createContractsArray (contacts) {
      const contracts = []
      for (var i = 0; i < contacts.length; i++) {
        if (contacts[i].documents.length) {
          for (let index = 0; index < contacts[i].documents.length; index++) {
            contacts[i].documents[index].historyId = contacts[i].history_id
            contacts[i].documents[index].contactId = contacts[i].contact_id
            contacts[i].documents[index].protocol = contacts[i].protocol
            contacts[i].documents[index].documentIndex = index
          }
          contracts.push(...contacts[i].documents)
        }
      }
      return contracts
    }

    function openPopover (status) {
      if (!validateProposal(vm.newProposal)) {
        vm.popover = false
        return
      }
      if (status && vm.popover) {
        vm.popover = false
        return
      }
      vm.popover = true
    }

    function validateProposal (proposal) {
      if (!proposal) {
        NotificationService.warningHandler('', 'É necessário inserir uma proposta')
        return false
      }
      if (proposal.length < 13) {
        NotificationService.warningHandler('', 'A proposta deve ter 13 caracteres')
        return false
      }
      for (let index = 0; index < vm.proposals.length; index++) {
        if (vm.proposals[index].proposta == proposal) {
          NotificationService.warningHandler('', 'Proposta já existe: ' + proposal)
          return false
        }
      }
      return true
    }

    function dateSelected (type, date) {
      if (type === 'from') {
        vm.pkadayToDate.setMinDate(date)
      }
      if (type === 'to') {
        vm.pkadayFromDate.setMaxDate(date)
      }
    }

    function switchTab (tab) {
      if (vm.preventDefault) {
        return false
      }
      if (tab == 'signatures') {
        vm.showTabSignature = true
        vm.showTabDocuments = false
        unwatchChanges()
      } else {
        watchChanges()
        vm.showTabSignature = false
        vm.showTabDocuments = true
      }
    }

    function uploadContactInfo (contract, contractIndex) {
      if (vm.preventDefault) {
        return false
      }
      vm.newProposal = null
      vm.proposalList = []
      vm.checkedAllProposals = false
      vm.proposals = contract.propostas
      vm.documents = contract
      vm.contractIndex = contractIndex
      vm.contractNumber = contract.contract
      vm.checkResend = checkResend()
      verifyStatusUploadPayroll()
      verifyStatusP3()
    }

    function downloadUploadFiles (files) {
      if (files == 'error') {
        NotificationService.warningHandler('', 'Não foi possível abrir os anexos, favor inserir novamente')
        return false
      }
      if (typeof (files) === 'object') {
        angular.forEach(files, function (url) {
          downloadByUrl(url)
        })
      } else {
        downloadByUrl(files)
      }
    }

    function downloadByUrl (url) {
      const anchor = angular.element('<a/>')
      anchor.css({
        display: 'none'
      })
      angular.element(document.body).append(anchor)
      anchor.attr({
        href: url,
        target: '_blank'
      })[0].click()
      anchor.remove()
    }

    function removeProposal (proposalNumber, uploadByJob) {
      if (uploadByJob) {
        DigitalSignService.deleteContactProposal({
          proposal: proposalNumber,
          contract: vm.contractNumber,
          flowName: vm.filters.flowName
        })
          .$promise
          .then(function (data) {
            if (!data.success) {
              NotificationService.warningHandler('', 'Não foi possível remover a proposta')
              return false
            }
          })
          .catch(function (data) {
            NotificationService.errorHandler('', 'Erro ao remover proposta')
            return false
          })
      }
      for (let index = 0; index < vm.proposals.length; index++) {
        if (vm.proposals[index].proposta === proposalNumber) {
          vm.proposals.splice(index, 1)
        }
      }
      NotificationService.successHandler(null, 'Proposta removida com successo')
      updateFlagContracts()
    }

    function callUploadProposalButton () {
      if (!validateProposal(vm.newProposal)) {
        vm.popover = false
        return false
      }
      angular.element('#digitalSignature_btn_uploadProposal').triggerHandler('click')
      return true
    }

    function uploadContracts (contracts) {
      let contractUpload = []
      if (contracts) {
        angular.forEach(contracts, function (file, key) {
          Upload.upload({
            url: apiUrl + '/upload-ccb',
            file: file
          })
            .then(function (data) {
              contractUpload.push(data.data.public_path)
              if (contracts.length === contractUpload.length) {
                addNewProposal(contractUpload)
              }
              NotificationService.successHandler(data, 'Upload de documento realizado com sucesso')
              vm.popover = false
            }).catch(function (data) {
              NotificationService.errorHandler(data, 'Erro ao realizar upload de documento')
              vm.popover = false
            })
        })
      }
    }

    function addNewProposal (contractUpload) {
      const newData = {
        ccb: contractUpload || null,
        proposta: vm.newProposal,
        contract: vm.contractNumber,
        statusUploadPayroll: 'noexists',
        statusP3: 'noexists',
        signed: false
      }
      vm.proposals.push(newData)
      vm.newProposal = null
      updateFlagContracts()
    }

    function searchContracts () {
      if (!validateProposal(vm.newProposal)) {
        vm.popover = false
        return false
      }
      vm.isLoading = true
      DigitalSignService.getDocumentList({
        proposal: vm.newProposal,
        flowName: vm.filters.flowName
      })
        .$promise
        .then(function (data) {
          if (data.success) {
            vm.documentList = data.result
            selectAllDocuments()
            FoundationApi.publish('dlgDocsSearchApiPayroll', 'open')
          } else {
            NotificationService.warningHandler(data, data.message || 'Houve um problema ao localizar a proposta')
          }
          vm.isLoading = false
          vm.popover = false
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, data.message)
          vm.isLoading = false
          vm.popover = false
        })
    }

    function selectAllDocuments () {
      Object.values(vm.documentList).forEach((document) => {
        if (vm.documentList.upload) {
          vm.documentList.upload[document.name] = true
        } else {
          vm.documentList.upload = []
          vm.documentList.upload[document.name] = true
        }
      })
    }

    function generateDocumentBySubscription () {
      vm.documentList.upload = filterByChecked(vm.documentList.upload)
      let proposalNumber = vm.newProposal

      DigitalSignService.generateDocumentBySubscription({
        proposal: proposalNumber,
        contract: vm.contractNumber,
        flowName: vm.filters.flowName,
        documents: Object.assign({}, vm.documentList.upload)
      })
        .$promise
        .then(function (data) {
          if (data.success) {
            if (Object.keys(vm.documentList.upload).length === 0) {
              FoundationApi.publish('dlgDocsSearchApiPayroll', 'close')
              NotificationService.warningHandler(null, 'Nenhum documento foi selecionado')
            } else {
              FoundationApi.publish('dlgDocsSearchApiPayroll', 'close')
              NotificationService.successHandler(null, 'Aguarde, os documentos estão sendo adicionados...')
              addNewProposal()
              disableButtonRemove(proposalNumber)
            }
            vm.popover = false
          }
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, data.message)
          vm.popover = false
        })
    }

    function checkResend () {
      for (let index = 0; index < vm.proposals.length; index++) {
        if (vm.proposals[index].signed && vm.contractNumber) {
          return true
        }
      }
      return false
    }

    function selectAllProposals () {
      vm.proposals.forEach(element => {
        if (element.contract == vm.contractNumber) {
          if (vm.checkedAllProposals) {
            vm.proposalList[element.proposta] = false
          } else {
            vm.proposalList[element.proposta] = true
          }
        }
      })

      if (vm.checkedAllProposals) {
        vm.checkedAllProposals = false
      } else {
        vm.checkedAllProposals = true
      }
    }

    function deselectAllProposals () {
      vm.proposals.forEach(element => {
        if (element.contract == vm.contractNumber) {
          vm.proposalList[element.proposta] = false
          vm.checkedAllProposals = false
        }
      })
    }

    function approveProposals () {
      vm.proposalList = filterByChecked(vm.proposalList)

      const proposalsNumber = prepareProposalsNumber()

      const checkResend = checkResendCount(proposalsNumber)

      if (!checkResend) {
        return false
      }

      if (!proposalsNumber.length) {
        NotificationService.warningHandler('', 'Não há contratos para serem enviados')
        return false
      }

      const proposalsPath = prepareProposalsPath()

      const payload = {
        flowName: vm.filters.flowName,
        proposals_numbers: Object.assign({}, proposalsNumber),
        phone: vm.documents.cellphone,
        proposals_paths: Object.assign({}, proposalsPath),
        data_nasc: vm.documents.birthdayOrFoundationDate,
        full_name: vm.documents.name,
        cpf: vm.documents.cpf,
        contract: vm.contractNumber,
        contactId: vm.documents.contactId,
        historyId: vm.documents.historyId
      }

      const valid = validateCustomerFields()

      if (!valid) {
        return false
      }

      DigitalSignService.approveProposal(payload)
        .$promise
        .then(function (data) {
          if (data.success) {
            NotificationService.successHandler('', 'Proposta(s) enviada(s) para assinatura')
            setSignedProposals(proposalsNumber)
            setSentSms(proposalsNumber)
            updateFlagContracts()
            deselectAllProposals()
          } else {
            NotificationService.warningHandler('', data.message)
          }
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, data.message)
        })
    }

    function validateCustomerFields () {
      if (!vm.documents.cpf) {
        NotificationService.warningHandler('', 'Favor inserir um CPF')
        return false
      }
      if (!vm.documents.name) {
        NotificationService.warningHandler('', 'Favor inserir o nome do cliente')
        return false
      }
      return true
    }

    function filterByChecked (payload) {
      Object.entries(payload).forEach(([key, value]) => {
        if (Object.keys(payload).length !== 0 && !value) {
          delete payload[key]
        }
      })
      return payload
    }

    function prepareProposalsNumber () {
      let proposalsNumber = []
      vm.proposals.forEach(element => {
        if (vm.proposalList[element.proposta] && element.ccb && !element.signed_ccb) {
          proposalsNumber.push(element.proposta)
        }
      })
      return proposalsNumber
    }

    function prepareProposalsPath () {
      let proposalsPath = []
      vm.proposals.forEach(element => {
        if (vm.proposalList[element.proposta] && element.ccb && !element.signed_ccb && element.ccb != 'error') {
          proposalsPath[element.proposta] = element.ccb
        }
      })
      return proposalsPath
    }

    function updateDocumentsInfo () {
      vm.documents.cpf = addMaskCpf(vm.documents.cpf)
      const payload = {
        flowName: vm.filters.flowName,
        documents: vm.documents,
        historyId: vm.documents.historyId,
        contactId: vm.documents.contactId
      }
      DigitalSignService.updateDocumentsInfoMultiple(payload)
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, 'Informações do cliente atualizadas com sucesso')
          updateFlagContracts()
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao atualizar os dados do cliente')
        })
      unwatchClick()
    }

    function addMaskCpf (cpf) {
      if (cpf) {
        return cpf.replace(/^([\d]{3})([\d]{3})([\d]{3})([\d]{2})$/, '$1.$2.$3-$4')
      }
      return cpf
    }

    function setSignedProposals (proposalsNumber) {
      vm.proposals.forEach((element, key) => {
        if (proposalsNumber.indexOf(element.proposta) !== -1) {
          vm.proposals[key].signed = true
        }
      })
      vm.checkResend = true
    }

    function setSentSms (proposalsNumber) {
      vm.proposals.forEach((element, key) => {
        if (proposalsNumber.indexOf(element.proposta) !== -1) {
          if (!vm.proposals[key].send_counter) {
            vm.proposals[key].send_counter = 0
          }
          vm.proposals[key].send_counter++
        }
      })
    }

    function disableButtonRemove (proposalNumber) {
      vm.proposals.forEach((element, key) => {
        if (proposalNumber == element.proposta) {
          vm.proposals[key].uploadDocument = true
        }
      })
    }

    function checkProposalsSent () {
      let match = 0
      vm.contracts.forEach((contract, indexContract) => {
        contract.propostas.forEach((proposal, proposalIndex) => {
          if (proposal.signed) {
            match++
          }
        })
        if (contract.propostas.length === 0) {
          vm.contracts[indexContract].proposalsSent = 'noexists'
        } else if (contract.propostas.length === match) {
          vm.contracts[indexContract].proposalsSent = true
        } else {
          vm.contracts[indexContract].proposalsSent = false
        }
        match = 0
      })
    }

    function checkProposalsSigned () {
      let match = 0
      vm.contracts.forEach((contract, indexContract) => {
        contract.propostas.forEach((proposal, proposalIndex) => {
          if (proposal.signed_ccb) {
            match++
          }
        })
        if (contract.propostas.length === 0) {
          vm.contracts[indexContract].proposalsSigned = 'noexists'
        } else if (contract.propostas.length === match) {
          vm.contracts[indexContract].proposalsSigned = true
        } else {
          vm.contracts[indexContract].proposalsSigned = false
        }
        match = 0
      })
    }

    function updateFlagContracts () {
      vm.contracts[vm.contractIndex].propostas = vm.proposals
      checkProposalsSent()
      checkProposalsSigned()
    }

    function verifyStatusUploadPayroll () {
      let match = 0
      vm.proposals.forEach((proposal, key) => {
        if (proposal.upload_payroll) {
          Object.values(proposal.upload_payroll).forEach(document => {
            if (!document) {
              match++
            }
          })
          if (match > 0) {
            vm.proposals[key].statusUploadPayroll = false
          } else {
            vm.proposals[key].statusUploadPayroll = true
          }
        } else if (!proposal.upload_payroll && proposal.kit_p3) {
          vm.proposals[key].statusUploadPayroll = false
        } else {
          vm.proposals[key].statusUploadPayroll = 'noexists'
        }
      })
    }

    function verifyStatusP3 () {
      vm.proposals.forEach((proposal, key) => {
        if (proposal.kit_p3) {
          vm.proposals[key].statusP3 = true
        } else if ((!proposal.kit_p3 && proposal.errors) || (!proposal.kit_p3 && proposal.signed_ccb)) {
          vm.proposals[key].statusP3 = false
        } else {
          vm.proposals[key].statusP3 = 'noexists'
        }
      })
    }

    function resubmitProposal (proposal, proposalIndex) {
      if (vm.proposals[proposalIndex].resubmitProposal) {
        NotificationService.warningHandler('', 'Aguarde uma solicitação já está sendo processada...')
        return false
      }

      const payload = {
        flowName: vm.filters.flowName,
        proposalNumber: proposal.proposta,
        proposal: proposal,
        historyId: vm.documents.historyId,
        documentIndex: vm.documents.documentIndex,
        proposalIndex: proposalIndex
      }

      FormalizationProposalStatusService
        .resubmitProposal(payload)
        .$promise
        .then(function (data) {
          if (data.success) {
            NotificationService.successHandler(data, 'Proposta reenviada! Envio em processamento...')
            vm.proposals[proposalIndex].resubmitProposal = true
          }
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Houve um erro ao reenviar')
        })
    }

    function downloadReport () {
      if (vm.preventDefault) {
        return false
      }
      if (validateFields()) {
        $http.get(apiUrl + '/formalization-proposal-status/downloadReport', { params: vm.filters })
          .then(function ({ data }) {
            if (data.warning) {
              NotificationService.warningHandler(data, data.message)
              return
            }
            const success = prepareFileForDownload(data)
            if (!success) {
              NotificationService.warningHandler(data, 'Nenhum contrato foi encontrado')
            }
          }, function () {
            NotificationService.errorHandler('', 'Erro ao gerar relatório')
          })
      }
    }

    function prepareFileForDownload (data) {
      let component = angular.element('<a/>')
      component.css({ display: 'none' })
      angular.element(document.body).append(component)

      let blob = new Blob([data], { type: 'text/csv' })

      if (blob.size <= 58) {
        return false
      }

      let csvUrl = URL.createObjectURL(blob)

      component.attr({
        href: csvUrl,
        target: '_self',
        download: 'formalization-proposal-status.csv'
      })[0].click()

      component.remove()
      URL.revokeObjectURL(csvUrl)

      return true
    }

    function validateFields () {
      const toDate = moment(vm.filters.toDate, 'DD/MM/YYYY')
      const fromDate = moment(vm.filters.fromDate, 'DD/MM/YYYY')
      if (toDate < fromDate) {
        NotificationService.warningHandler('', 'Data inicial inválida')
        return false
      }
      if (toDate.diff(fromDate, 'days') > 30) {
        NotificationService.warningHandler('', 'Periodo máximo de busca é de 30 dias')
        return false
      }
      return true
    }

    function scrollHandle () {
      if (vm.currentQuantity < vm.totalAmount) {
        getContracts(true)
        return Promise.resolve(true)
      }
      return Promise.resolve(false)
    }

    function checkResendCount (proposalsNumbers) {
      if ($rootScope.checkMenuAccess('digitalSignature.unlimitedResend')) {
        return true
      }

      // eslint-disable-next-line semi
      const limit = $rootScope.company_metadata.max_formalization_send_quantity;

      if (limit === undefined) {
        return true
      }

      for (let i = 0; i < proposalsNumbers.length; i++) {
        const proposalNumber = proposalsNumbers[i]
        for (let j = 0; j < vm.proposals.length; j++) {
          const proposal = vm.proposals[j]
          if (proposalNumber == proposal.proposta && proposal.send_counter >= limit) {
            NotificationService.warningHandler('', 'As tentativas de reenvio do link foram esgotadas para a proposta: ' + proposal.proposta +
            ', gentileza verificar junto ao cliente se o telefone do mesmo é ativo para recebimento de SMS')
            return false
          }
        }
      }
      return true
    }

    function goToButtonSaveDocuments () {
      angular.element('#digital-signature-documents_btn_saveDocuments')[0].scrollIntoView({
        behavior: 'auto',
        block: 'center',
        inline: 'center'
      })
    }

    // unsaved-changes START

    function watchChanges () {
      angular.element('#digital-signature-documents_div_containerDocuments').on('change', () => {
        const regexPattern = RegExp('digital-signature-documents')
        vm.preventDefault = true
        if (!vm.hasUnsavedChanges) {
          angular.element('body').on('click', validateChange(regexPattern))
          vm.hasUnsavedChanges = true
        }
      })
    }

    function unwatchClick () {
      vm.preventDefault = false
      vm.hasUnsavedChanges = false
      angular.element('body').off('click')
    }

    function unwatchChanges () {
      angular.element('#digital-signature-documents_div_containerDocuments').off('change')
    }

    function validateChange (regexPattern) {
      return (e) => {
        let elemId = e.target.parentNode.id || e.target.id
        if (!regexPattern.exec(elemId)) {
          e.preventDefault()
          e.stopPropagation()
          FoundationApi.publish('confirmModal', 'open')
        }
      }
    }

    function confirmModal () {
      updateDocumentsInfo()
      FoundationApi.publish('confirmModal', 'close')
    }

    function closeConfirmModal () {
      FoundationApi.publish('confirmModal', 'close')
      unwatchClick()
    }
    // unsaved-changes END
  }
  // eslint-disable-next-line semi
})();
